import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Showcase,
  Header,
  SectionTitle,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        slug={data.slug + '/develop/'}
        site={data.site}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            The account card presents the user with actions and information
            associated with their bank accounts. The account name or nickname
            and the last four digits of the account number tell the user which
            of their accounts they are looking at. The mandatory primary balance
            appears as an amount with a label, and an optional secondary balance
            displays an amount and a label with or without a due date. Use an{' '}
            <Link
              className="link"
              to={'/' + data.site + '/components/link/develop'}
            >
              icon link
            </Link>{' '}
            to offer contextual help only if the balance label needs further
            explanation.
          </p>

          <p>
            The actions account card links the user to the account activity and
            details view while also presenting up to three actions associated
            with the account. An optional status bar will display temporary or
            urgent account information, such as a past due balance.
          </p>
        </Intro>

        <SectionTitle>Variants</SectionTitle>
        <Showcase
          full={true}
          site={data.site}
          title="Standard"
          text={
            <p>
              Used when there is enough space for 1 - 3 account-level actions to
              fit horizontally within the card. Actions are presented as icons
              with a label. The green arrow next to the account number links to
              the account activity and detail view.
            </p>
          }
        >
          <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
            <div class="c-card__body--small u-flex-wrap--wrap">
              <div>
                <a href="#" class="c-card__title--actionable">
                  EZChoice Checking{' '}
                  <span class="c-card__title-sub">....5356</span>
                  <i class="c-card__title--actionable-icon icon icon--arrow-without-tail-right"></i>
                  {/* Have to revisit whether the card title in the acct cards is always green even when it's not part of the link, i.e. clickable. Currently built, only the arrow should be clickable.*/}
                </a>
              </div>
              <div class="u-display--inline-block l-margin-right--large">
                <div class="c-title-2--normal">
                  <sup class="u-type--small">$</sup>1,000.00
                </div>
                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Balance Label
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
              <div class="u-display--inline-block">
                <div class="c-title-2--normal">
                  <span class="u-type--medium">$1,000.00</span>{' '}
                  <span class="u-type--xsmall">due on 12/31/20</span>
                </div>
                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Balance Label
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
            </div>
            <ul class="c-horizontal-list">
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--counter-directional"></i>
                  <span class="c-horizontal-list__text">Transfer</span>
                </a>
              </li>
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--receipt"></i>
                  <span class="c-horizontal-list__text">Statment</span>
                </a>
              </li>
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--envelope-with-currency"></i>
                  <span class="c-horizontal-list__text">Send Money</span>
                </a>
              </li>
            </ul>
          </div>
        </Showcase>

        <Showcase
          full={true}
          site={data.site}
          title="Link Only"
          text="Used when there are no other associated account actions associated with the account. The arrow linking to the account activity and details view gets a more prominent placement."
        >
          <div class="c-card__border-top u-flex-container u-flex-wrap--wrap">
            <div class="c-card__body--small u-flex-wrap--wrap">
              <div>
                <a href="#" class="c-card__title--actionable">
                  EZChoice Checking{' '}
                  <span class="c-card__title-sub">....555356</span>
                </a>
                {/* The above element should not be a link, this is static text */}
              </div>
              <div class="u-display--inline-block l-margin-right--large">
                <div class="c-title-2--normal">
                  <sup class="u-type--small">$</sup>1,000.00
                </div>
                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Balance Label
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
              <div class="u-display--inline-block">
                <div class="c-title-2--normal">
                  <span class="u-type--medium">$1,000.00</span>{' '}
                  <span class="u-type--xsmall">due on 12/31/20</span>
                </div>
                <div class="c-label u-type--xsmall u-display--inline l-margin-bottom--none l-margin-right--xxsmall">
                  Balance Label
                </div>
                <a href="" class="c-icon-link u-type--xsmall u-display--inline">
                  <i class="icon icon--question c-icon-link__icon u-type--xsmall"></i>
                  What's this?
                </a>
              </div>
            </div>
            <ul class="c-horizontal-list">
              <li class="c-horizontal-list__item">
                <a href="" class="c-horizontal-list__link">
                  <i class="c-horizontal-list__icon icon icon--arrow-without-tail-right" />
                </a>
              </li>
            </ul>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Status Bar</SectionTitle>
        <Showcase
          full={true}
          site={data.site}
          title="Status"
          text={
            <p>
              Used to display temporary or urgent account information on either
              of the above variants. The yellow bar at the top of the card will
              change color to match the corresponding status. Consult our{' '}
              <Link
                className="link"
                to={'/' + data.site + '/guidelines/status/develop'}
              >
                status guidelines
              </Link>{' '}
              when adding the status bar.
            </p>
          }
        ></Showcase>
        <hr />

        <SectionTitle>Error States</SectionTitle>
        <p>
          The card will display various errors when balance information can't be
          recalled.
        </p>
        <Showcase
          site={data.site}
          title="Functional"
          text="Used when some of the information in the account card can't be shown but the associated actions are still functional. Only show errors where the information is missing. The yellow bar will remain yellow in the error state unless using a status bar."
        ></Showcase>
        <Showcase
          site={data.site}
          title="Non-Functional"
          text="When no information can be shown, or the actions on the card are not functional, the error message will appear without a border."
        ></Showcase>

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Both the standard and link only variants of the actions account card
          will stack when space is limited.
        </p>
        <Showcase
          site={data.site}
          title="Standard stacked"
          text="Used when the actions variant will only fit along the bottom of the card. Help links may use the icon only variation at this width."
        ></Showcase>
        <Showcase
          site={data.site}
          title="Link only stacked"
          text="Used when the two balances won't fit side by side. Help links may use the icon only variation at this width."
        ></Showcase>
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Action labels should use strong verbs and specific language, similar
          to{' '}
          <Link
            class="link"
            to={'/' + data.site + '/components/button/develop'}
          >
            buttons
          </Link>{' '}
          . Icon labels and balance labels should stay on a single line of text.
          The status bar should be a short descriptive sentence ending in a
          period. Otherwise, follow the microcopy guidelines for the{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/link/develop'}
          >
            link
          </Link>{' '}
          and{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/link/develop'}
          >
            label
          </Link>{' '}
          components.
        </p>
      </Layout>
    </>
  )
}
